import { styled } from "goober";
import { useEffect, useState } from "react";
import { zIndexes } from "../../lib/zIndexes";
import { AnchoredPopover } from "../AnchoredPopover";
import { getPositionStyles } from "../Tooltip";

const Popover = styled(AnchoredPopover)`
  background: var(--tooltip-bg);
  color: var(--tooltip-fg);
  box-shadow: var(--elevation-low);
  padding: 6px 8px;
  z-index: ${zIndexes.tooltip};
  width: max-content;
  pointer-events: none;
  font-weight: 450;
  font-size: 10px;
  line-height: 12px;
`;

type Props = {
  anchorName: string;
  anchorRef: React.RefObject<HTMLElement | null>;
  direction: "up" | "down";
  count: number;
};

// Shown while an edge highlight is active, hugging the card's top-left corner
// for upstream and top-right for downstream, flipping below when near the top.
export function EdgeFlowTooltip({
  anchorName,
  anchorRef,
  direction,
  count,
}: Props) {
  const [position, setPosition] = useState<React.CSSProperties>({});

  useEffect(() => {
    const rect = anchorRef.current?.getBoundingClientRect();
    const vertical = rect && rect.top < 60 ? "below" : "above";
    setPosition(
      getPositionStyles(direction === "up" ? "left" : "right", vertical)
    );
  }, [anchorRef, direction]);

  const noun = direction === "up" ? "upstream" : "downstream";
  return (
    <Popover isOpen target={anchorName} style={position} trigger={() => null}>
      {`${count} ${noun} step${count === 1 ? "" : "s"}`}
    </Popover>
  );
}
